"use strict";

exports.__esModule = true;

/* eslint-disable no-param-reassign */

exports.default = function (colors, obj, prefix) {
  return Object.keys(obj).forEach(function (color) {
    colors[prefix + "-" + color] = obj[color];
  });
};